import { render, staticRenderFns } from "./secondary.vue?vue&type=template&id=2d593180&scoped=true&"
import script from "./secondary.vue?vue&type=script&lang=js&"
export * from "./secondary.vue?vue&type=script&lang=js&"
import style0 from "./secondary.vue?vue&type=style&index=0&id=2d593180&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d593180",
  null
  
)

export default component.exports